import { render } from "./ProductSectionCard.vue?vue&type=template&id=ca81c616"
import script from "./ProductSectionCard.vue?vue&type=script&lang=js"
export * from "./ProductSectionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__